import { _decorator, Node } from 'cc';
import { SpinResult } from '../../../../Data/DataObject/SlotResult';
import BasicHistoryRecord from './BasicHistoryRecord';

const { ccclass, property } = _decorator;

@ccclass('NormalPlayHistoryRecord')
export default class NormalPlayHistoryRecord extends BasicHistoryRecord {
    @property(Node)
    private readonly freeGameTag: Node = null;

    @property(Node)
    private readonly jackpotTag: Node = null;

    protected updateContent(): void {
        super.updateContent();
        this._updateTags(this.historyData.result);
    }

    private _updateTags(result: SpinResult) {
        if (result) {
            this.freeGameTag.active = result.triggerFG;
            this.jackpotTag.active = result.triggerJP;
        } else {
            this.freeGameTag.active = false;
            this.jackpotTag.active = false;
        }
    }
}
